import { ERC725YDataKeys } from '@lukso/lsp-smart-contracts'
import Eth from 'web3-eth'

import { getDataABI } from '@/shared/abis/getDataABI'
import { EoaAddress, UpAddress } from '@/shared/models/Profile'
import { logError } from '@/shared/logger'

export const checkIfUniversalReceiverAccount = async (
  web3Eth: Eth,
  upAddress: UpAddress,
  address: EoaAddress
) => {
  try {
    const LSP1UniversalReceiverDelegate: string = await new web3Eth.Contract(
      getDataABI,
      upAddress
    ).methods['getData(bytes32)'](
      ERC725YDataKeys.LSP1.LSP1UniversalReceiverDelegate
    ).call()
    return LSP1UniversalReceiverDelegate.toUpperCase() === address.toUpperCase()
  } catch (error) {
    logError(`Error while checking LSP1UniversalReceiverDelegate:`, error)
    return false
  }
}
